import { PlatformAdminRole } from '../enums/platform-admin.enum';
export const PLATFORM_ROLE_DEFINITIONS = {
  [PlatformAdminRole.SUPER_ADMIN]: {
    key: PlatformAdminRole.SUPER_ADMIN,
    label: 'Super Admin',
    description: 'Full platform administration access',
    default_permissions: ['*'],
    is_system: true
  },
  [PlatformAdminRole.SUPPORT_ADMIN]: {
    key: PlatformAdminRole.SUPPORT_ADMIN,
    label: 'Support Admin',
    description: 'Tenant and operations support management',
    default_permissions: ['tenants.read', 'tenants.manage', 'support.read', 'support.manage', 'jobs.read', 'jobs.manage', 'misa.manage'],
    is_system: true
  },
  [PlatformAdminRole.BILLING_ADMIN]: {
    key: PlatformAdminRole.BILLING_ADMIN,
    label: 'Billing Admin',
    description: 'Billing, invoices, and financial reporting management',
    default_permissions: ['billing.read', 'billing.manage', 'plans.read', 'plans.manage', 'reports.read', 'reports.export', 'orders.read'],
    is_system: true
  }
};
export const PLATFORM_PERMISSION_GROUPS = [{
  key: 'tenant',
  label: 'Khach thue',
  permissions: [{
    key: 'tenants.read',
    label: 'Xem danh sach khach thue'
  }, {
    key: 'tenants.manage',
    label: 'Quan ly vong doi khach thue'
  }, {
    key: 'tenants.impersonate',
    label: 'Dang nhap gia lap tenant'
  }]
}, {
  key: 'billing',
  label: 'Thanh toan',
  permissions: [{
    key: 'billing.read',
    label: 'Xem du lieu billing'
  }, {
    key: 'billing.manage',
    label: 'Quan ly hoa don/goi cuoc'
  }, {
    key: 'plans.read',
    label: 'Xem goi cuoc'
  }, {
    key: 'plans.manage',
    label: 'Quan ly goi cuoc'
  }, {
    key: 'reports.read',
    label: 'Xem bao cao'
  }, {
    key: 'reports.export',
    label: 'Xuat bao cao'
  }]
}, {
  key: 'ops',
  label: 'Van hanh he thong',
  permissions: [{
    key: 'jobs.read',
    label: 'Xem hang doi'
  }, {
    key: 'jobs.manage',
    label: 'Dieu phoi/retry hang doi'
  }, {
    key: 'support.read',
    label: 'Xem phieu ho tro'
  }, {
    key: 'support.manage',
    label: 'Xu ly phieu ho tro'
  }, {
    key: 'system.manage',
    label: 'Cau hinh he thong'
  }, {
    key: 'users.manage',
    label: 'Quan ly tai khoan admin'
  }, {
    key: 'misa.manage',
    label: 'Quan ly dong bo MISA'
  }, {
    key: 'orders.read',
    label: 'Xem don hang'
  }]
}];
//# sourceMappingURL=platform-admin-rbac.js.map